import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useOutfitting } from '@common-vue/outfitting/src/composables/useOutfitting';
import { useBrand } from '@composables/useBrand';
import { useOutfittingData } from '@composables/useOutfittingData';
import { usePageData } from '@composables/usePageData';
import { useFeatureEligibility } from '@modules/featureControl';
import { useProductImagesCtaActions } from './useProductImagesCtaActions';
import { fireLinkTag } from '../../features/analytics/tagManager';

export const useOutfittingCta = () => {
  const { outfittingProps } = useOutfittingData();
  const { featureFlags } = outfittingProps.value;
  const { pdpCtaItemData, pdpOutfitAvailabilityCheck } = useOutfitting();
  const { addCtaItem } = useProductImagesCtaActions();

  const brandFlags = useBrand();
  const store = useStore();

  const hasOutfits = computed(() => store.state.outfittingStore.outfitsAvailability || false);

  // Must be set to true once store action to add the CTA item is called.
  const isAdded = ref(false);

  function addCta() {
    const itemData = {
      // passing lexical scope for [store] is needed
      ...pdpCtaItemData({
        brandFlags,
        featureFlags,
        fireLinkTag,
      }, store),
      customCssClass: 'font-small',
      showArrow: true,
    };
    addCtaItem(itemData);
    isAdded.value = true;
  }

  async function init() {
    const { product } = usePageData();
    const { isShoppable } = useFeatureEligibility();
    const isProductAvailable = product?.product?.availability?.available || false;

    // help prevent unnecessary API calls going out if product is not available
    if (!isProductAvailable) return;

    // passing lexical scope for [store] is needed
    await pdpOutfitAvailabilityCheck(outfittingProps.value, store);
    if (hasOutfits.value && !isShoppable) addCta();
  }

  return {
    init,
    isAdded,
  };
};

export default useOutfittingCta;
